import React from "react";
import estilo from "./styles/Paginacion.module.css";

function Paginacion({
  posicionesTotales,
  cantidadPorPagina,
  setPaginaActual,
  paginaActual,
}) {
  let paginas = [];

  for (let i = 1; i <= Math.ceil(posicionesTotales / cantidadPorPagina); i++) {
    paginas.push(i);
  }
  return (
    <div className={estilo.paginacion}>
      {paginas.map((pagina, index) => {
        return (
          <button
            key={index}
            onClick={() => setPaginaActual(pagina)}
            className={pagina === paginaActual ? `${estilo.activo}` : ""}
          >
            {pagina}
          </button>
        );
      })}
    </div>
  );
}

export default Paginacion;
